import { useContext, useEffect, useRef } from "react";
import { HamiltonianContext } from "../Hamiltonian/HamiltonianOperator";
import { useFrame } from "@react-three/fiber";

function complexToRgba(re, im) {
  const amp = Math.min(Math.hypot(re, im), 1);
  const phase = Math.atan2(im, re);
  const h = (phase + Math.PI) / (2 * Math.PI);

  const r = Math.abs(h * 6 - 3) - 1;
  const g = 2 - Math.abs(h * 6 - 2);
  const b = 2 - Math.abs(h * 6 - 4);

  return [r, g, b, amp];
}

export default function Particle() {
  const ref = useRef();
  const { psiRe, psiIm, colors, count, positions } =
    useContext(HamiltonianContext);

  // initial Gaussian Wavepacket
  useEffect(() => {
    for (let i = 0; i < count; i++) {
      psiRe.current[i] = Math.exp(-0.5 * positions.current[i * 3] ** 2);
      psiIm.current[i] = 0;
    }
  }, []);

  useFrame(() => {
    for (let i = 0; i < count; i++) {
      const [r, g, b, a] = complexToRgba(psiRe.current[i], psiIm.current[i]);
      colors.current[i * 4 + 0] = r;
      colors.current[i * 4 + 1] = g;
      colors.current[i * 4 + 2] = b;
      colors.current[i * 4 + 3] = a;
    }
    ref.current.geometry.attributes.color.needsUpdate = true;
  });

  return (
    <points ref={ref}>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-position"
          array={positions.current}
          count={count}
          itemSize={3}
        />
        <bufferAttribute
          attach="attributes-color"
          array={colors.current}
          count={count}
          itemSize={4}
        />
      </bufferGeometry>
      <pointsMaterial vertexColors transparent size={1} />
    </points>
  );
}
